import React, { PureComponent, createRef } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import moment from 'moment-timezone';
import { subscribeToEmailWhenSpotOpenUp } from '../../redux/actions';
import { DatePicker, Modal, DropdownContainer } from "../index";
import { Bell } from '../../utils';

import { Container, Header, InputContainer, SubmitButton, Input, Error, Disclaimer } from './styles';

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email')
    .required('Email is required')
});

const mapStateToProps = state => ({
  userData: state.user.userData,
  selectedDate: state.userPreferences.date,
  productId: state.userProduct.product.id,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleFormSubmit: subscribeToEmailWhenSpotOpenUp,
}, dispatch);

@connect(mapStateToProps, mapDispatchToProps)
class SignUpForEmailAlertModal extends PureComponent {
  static propTypes = {
    handleFormSubmit: PropTypes.func,
    userData: PropTypes.instanceOf(Object),
    selectedDate: PropTypes.string,
    productId: PropTypes.number,
  };

  formik = createRef();

  constructor(props) {
    super(props);
    const { selectedDate } = props;

    this.state = {
      isOpen: false,
      selectedDate: moment(selectedDate).format('MMM D, YYYY'),
    }
  }

  onFormSubmit = ({ email, date }) => {
    const { handleFormSubmit, productId } = this.props;
    handleFormSubmit({ email, date, productId });
  };

  handleDropdown = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
    }))
  };

  handleDateSelection = date => {
    this.setState({
      selectedDate: moment(date).format('MMM D, YYYY'),
    });

    this.formik.current.setFieldValue('date', moment(date).format('YYYY-MM-DD'));
    this.closeDropdown();
  };

  closeDropdown = () => {
    this.setState({
      isOpen: false,
    })
  };

  render() {
    const { handleDropdown, closeDropdown, handleDateSelection, onFormSubmit } = this;
    const { isOpen, selectedDate } = this.state;
    const { userData } = this.props;

    return (
      <Modal empty maxWidth="500px" mobileMaxWidth='98%' overflow="visible">
        <Container>
          <Header>
            <Bell />
            Extra spots up often, <br />you will be first to know!
          </Header>
          <Formik
            initialValues={{
              email: userData ? userData.emailAddress : '',
              date: selectedDate ? moment(selectedDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
            }}
            validationSchema={validationSchema}
            onSubmit={onFormSubmit}
            ref={this.formik}
          >
            {({ errors, touched, handleBlur, handleChange, values }) => (
              <Form>
                <InputContainer>
                  <Input
                    as="button"
                    type="button"
                    onClick={handleDropdown}
                  >
                    {selectedDate}
                  </Input>
                  {isOpen && (
                    <DropdownContainer name="date" handleCloseButtonClick={closeDropdown} onClickOutside={closeDropdown}>
                      <DatePicker
                        handleDayClick={handleDateSelection}
                        onClickOutside={closeDropdown}
                        selectedDate={selectedDate}
                      />
                    </DropdownContainer>
                  )}
                </InputContainer>
                <InputContainer>
                  <Input
                    type="email"
                    placeholder="Enter email..."
                    name="email"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.email}
                  />
                  {errors.email && touched.email && <Error>{errors.email}</Error>}
                </InputContainer>
                <SubmitButton type="submit" htmlType="submit" btnType="primary">
                  Add me to waitlist
                </SubmitButton>
              </Form>
            )}
          </Formik>
          <Disclaimer>
            By continuing, you agree to our <a href="/terms" className="link-terms" target="noopener noreferrer">Terms of Use</a>
          </Disclaimer>
        </Container>
      </Modal>
    )
  }
}

export default SignUpForEmailAlertModal;
